import React from "react";
import HeaderMenu from "../component/Navbar/headermenu";
import HeroSection from "../component/Careers/HeroSection";
import { OurCulture } from "../component/Careers/OurCulture";
import OurPositions from "../component/Careers/OurPositions";
import PerksBenefits from "../component/Careers/PerksBenefits";
import OurProcess from "../component/Careers/OurProcess";
import HearFromOurteam from "../component/Careers/HearFromOurteam";
import CustomFooter from "../component/Footer/customFooter";

const Careers = () => {
  return (
    <>
      <HeaderMenu />
      <section>
        <HeroSection />
        <div className="px-[16px] sm:px-[36px]">
          <OurCulture />
        </div>
        <div id="ourpositions">
          <OurPositions />
        </div>
        <PerksBenefits />
        <OurProcess />
        <HearFromOurteam />
        <CustomFooter />
      </section>
    </>
  );
};

export default Careers;
